export const normalizeWebUrl = (value: string): string | null => {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
        return null;
    }

    const hasUnsafeCharacter = [...trimmedValue].some(
        (character) =>
            character.codePointAt(0)! <= 32 || ['"', "'", '<', '>', '`'].includes(character)
    );

    if (hasUnsafeCharacter) {
        return null;
    }

    const protocol = /^([a-z][a-z\d+.-]*):/i.exec(trimmedValue)?.[1]?.toLowerCase();

    if (protocol && !['http', 'https'].includes(protocol)) {
        return null;
    }

    const normalizedValue = protocol ? trimmedValue : `https://${trimmedValue}`;

    try {
        const url = new URL(normalizedValue);

        if (!['http:', 'https:'].includes(url.protocol) || !url.hostname.includes('.')) {
            return null;
        }

        return normalizedValue;
    } catch {
        return null;
    }
};
